module.exports = __webpack_public_path__ + "static/media/likeStars.40726d7e.svg";